export default [
  {
    label: '周一',
    value: 1,
    checked: true,
  },
  {
    label: '周二',
    value: 2,
    checked: true,
  },
  {
    label: '周三',
    value: 3,
    checked: true,
  },
  {
    label: '周四',
    value: 4,
    checked: true,
  },
  {
    label: '周五',
    value: 5,
    checked: true,
  },
  {
    label: '周六',
    value: 6,
    checked: true,
  },
  {
    label: '周日',
    value: 0,
    checked: true,
  },
]
